import { render, staticRenderFns } from "./EmploymentModels.vue?vue&type=template&id=6480a978&scoped=true&"
import script from "./EmploymentModels.vue?vue&type=script&lang=js&"
export * from "./EmploymentModels.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentModels.vue?vue&type=style&index=0&id=6480a978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6480a978",
  null
  
)

export default component.exports